module.exports = __webpack_public_path__ + "static/img/protect_2.547cbacc.png";